import { createActionGroup, emptyProps, props } from '@ngrx/store'
import { PaymentOrder, PaymentSuccessResponse, PaymentBBSuccessResponse } from './payment'

export const PaymentActions = createActionGroup({
	source: 'Payment',
	events: {
		'Set Payment Order': props<{ paymentOrder: PaymentOrder }>(),
		'Create Payment': props<{
			dynamicCVV?: string
			paymentMethod?: 'PIX' | 'BLT' | 'OPT' | 'DEB' | 'CRT' | 'LIV'
		}>(),
		'Create Payment Success': props<{ res: PaymentSuccessResponse }>(),
		'Create Payment Failure': props<{ error: string }>(),
		'Create BB Payment Success': props<{ res: PaymentBBSuccessResponse }>(),
		'Reset Payment Status': emptyProps(),
	},
})
